/**
 * @generated SignedSource<<9f00722edd7dd92fc7bb123b712df9ac>>
 * @relayHash 55904113b6600f231b77335f26a98489
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e4ee3031fb1644b53d4cd959e35adde7573601ce24da28ed2f0a9f1644204b71

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateAffectedServicesFieldInput = {
  id: string;
  operation: JiraAffectedServicesFieldOperationInput;
};
export type JiraAffectedServicesFieldOperationInput = {
  ids?: ReadonlyArray<string> | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type useSaveAffectedServicesField_AffectedServicesMutation$variables = {
  input: JiraUpdateAffectedServicesFieldInput;
};
export type useSaveAffectedServicesField_AffectedServicesMutation$data = {
  readonly jira: {
    readonly updateAffectedServicesField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSaveAffectedServicesField_AffectedServicesMutation$rawResponse = {
  readonly jira: {
    readonly updateAffectedServicesField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useSaveAffectedServicesField_AffectedServicesMutation = {
  rawResponse: useSaveAffectedServicesField_AffectedServicesMutation$rawResponse;
  response: useSaveAffectedServicesField_AffectedServicesMutation$data;
  variables: useSaveAffectedServicesField_AffectedServicesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraAffectedServicesFieldPayload",
        "kind": "LinkedField",
        "name": "updateAffectedServicesField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraAffectedServicesField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSaveAffectedServicesField_AffectedServicesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveAffectedServicesField_AffectedServicesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "e4ee3031fb1644b53d4cd959e35adde7573601ce24da28ed2f0a9f1644204b71",
    "metadata": {},
    "name": "useSaveAffectedServicesField_AffectedServicesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ca3dc1506e80ac98c261e21dc7d93016";

export default node;
